import { FC, ReactNode } from 'react';

import { Box, DialogContent, PaperProps, Typography, useTheme } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { noop } from 'lodash';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import BaseModalWrapper from '@components/share/modal/baseModalWrapper';

type BaseWarningModalProps = {
  isOpen: boolean;
  onClose: typeof noop;
  title: string;
  description: string | ReactNode;
  actions?: ReactNode;
  titleSx?: SxProps<Theme>;
  paperStyle?: Partial<PaperProps['sx']>;
};

const BaseWarningModal: FC<BaseWarningModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  actions,
  titleSx,
  paperStyle = {},
}) => {
  const theme = useTheme();

  const RenderDescription = () => {
    if (!description) {
      return null;
    }
    if (typeof description === 'string') {
      return (
        <Typography variant="body1lanna" component="p" sx={{ whiteSpace: 'pre-wrap', textAlign: 'center' }}>
          {description}
        </Typography>
      );
    }
    return description;
  };

  return (
    <BaseModalWrapper
      open={isOpen}
      onClose={onClose}
      paperStyle={{ width: 450, padding: '24px', ...paperStyle }}
      disabledBackDrop
    >
      <DialogContent sx={{ px: { xs: 0, md: 1 }, pb: 2 }}>
        <Box display="flex" justifyContent="center" mb={3}>
          <FontAwesomeIcon
            style={{ fontSize: '48px' }}
            color={theme.palette.textV2.disabled}
            icon="fa-light fa-circle-exclamation"
          />
        </Box>

        <Typography variant="h4" sx={{ whiteSpace: 'pre-wrap', textAlign: 'center', mb: 2, ...titleSx }}>
          {title}
        </Typography>

        {RenderDescription()}
      </DialogContent>

      {actions}
    </BaseModalWrapper>
  );
};

export default BaseWarningModal;
